export interface Breadcrumb {
  label: string;
  href: string;
}

const title = ref<string>("Scodi Store Service");
const breadcrumbs = ref<Breadcrumb[]>([]);

export const useHeaderData = () => {
  return {
    addTitle(titleToAdd: string) {
      title.value = titleToAdd;
    },
    addBreadcrumbs(breadcrumbsToAdd: Breadcrumb[]) {
      breadcrumbs.value = breadcrumbsToAdd;
    },
    title,
    breadcrumbs,
  };
};
